<i18n>
{
  "en": {
    "fields" : {
      "rules": {
        "add": "Add rule",
        "required": "Required field",
        "nospace": "No space character"
      }
    }
  }
}
</i18n>

<template>
  <div>
    <div
      v-for="(rule, ruleindex) in rules"
      :key="`rule-${ruleindex}`"
    >
      <div class="row">
        <div class="col">
          <select
            v-model="rules[ruleindex]"
            class="form-control"
          >
            <option
              v-for="(availableRule, availableRuleindex) in availableRules"
              :key="`availablerule-${availableRuleindex}`"
              :value="availableRule.id"
              v-html="$t(`fields.rules.${availableRule.id}`)"
            ></option>
          </select>
        </div>
        <div class="col">
          <button
            class="btn btn-default"
            @click="removeRule(ruleindex)"
          >
            <font-awesome-icon icon="minus" />
          </button>
        </div>
      </div>
    </div>
    <div>
      <button
        class="btn btn-success"
        @click="addRule()"
      >
        {{ $t(`fields.rules.add`) }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExtensionRules',
  props: ['rules'],
  data() {
    return {
      availableRules: [
        {
          id: 'required',
        },
        {
          id: 'nospace',
        },
      ],
    };
  },
  methods: {
    addRule() {
      this.rules.push({
        id: '',
      });
    },
    removeRule(index) {
      this.rules.splice(index, 1);
    },
  },
};
</script>
